module.exports = __webpack_public_path__ + "static/img/sgsan.2cae6b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sgsan.png
// module id = qj3n
// module chunks = 0